import { format } from "date-fns";
import { Banner } from "@jsq/ds/core";
import { useFormContext } from "@jsq/ds/forms";
import { formatSubType } from "~/pages/Compliance/utils/documentUtils";
import { FormValues } from "../types";
import { isDocumentExpired } from "../utils";

export const DocumentExpiredBanner = () => {
  const { values, initialValues } = useFormContext<FormValues>();
  const { secondaryDocumentType, date, expiryDate, documentExpiryDate } = values;

  // For ID documents, use expiryDate; for other documents, use date
  const currentDate = expiryDate ?? date;
  const initialDate = initialValues.expiryDate ?? initialValues.date;

  if (
    !currentDate ||
    !isDocumentExpired(currentDate, initialDate, documentExpiryDate, secondaryDocumentType)
  )
    return null;

  const formattedDate = format(currentDate, "MMM d, yyyy");
  const formattedSubType = formatSubType(secondaryDocumentType);
  const documentLabel =
    formattedSubType && formattedSubType !== "--" ? `${formattedSubType} document` : "Document";

  return (
    <Banner
      variant="warning"
      title={`${documentLabel} has expired on ${formattedDate}`}
      description={`Please upload an updated ${documentLabel}.`}
    />
  );
};
